"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddButtonRoot = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _colorPickerTheme = require("../../../../colorPickerTheme");
// @TODO Refactor this to use the actual button under the hood
const AddButtonRoot = (0, _styled.default)("button")`
    ${_ref => {
  let {
    themeMode
  } = _ref;
  return `
        width: ${_colorPickerTheme.colorPickerTheme.colorButton.size(themeMode)};
        height: ${_colorPickerTheme.colorPickerTheme.colorButton.size(themeMode)};
        color: ${_colorPickerTheme.colorPickerTheme.colorSelector.addButton.color.rest(themeMode)};
        background-color: ${_colorPickerTheme.colorPickerTheme.colorSelector.addButton.backgroundColor.rest(themeMode)};
        border: none;
        box-sizing: border-box;
        border-radius: ${_colorPickerTheme.colorPickerTheme.colorButton.borderRadius(themeMode)};
        position: relative;
        display: inline-flex;
        margin: ${_colorPickerTheme.colorPickerTheme.colorButton.margin(themeMode)};
        cursor: pointer;
        align-items: center;
        justify-content: center;
        vertical-align: -5px;
        order: ${_colorPickerTheme.colorPickerTheme.colorSelector.addButton.order(themeMode)};
        > span > svg {
            pointer-events: none;
        }

        &:before {
            content: "";
            display: block;
            box-sizing: border-box;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 28px;
            height: 28px;
            border-radius: 50%;
            border-width: 2px;
            border-style: solid;
            border-color: transparent;
        }

        &:focus {
            outline: none;
        }

        &:focus:before {
            border-color: ${_colorPickerTheme.colorPickerTheme.colorButton.before.color.focus(themeMode)};
        }

        &:hover {
            background-color: ${_colorPickerTheme.colorPickerTheme.colorSelector.addButton.backgroundColor.hover(themeMode)};
        }
        &:active {
            background-color: ${_colorPickerTheme.colorPickerTheme.colorSelector.addButton.backgroundColor.active(themeMode)};
        }
        &[aria-disabled="true"] {
            color: ${_colorPickerTheme.colorPickerTheme.colorSelector.addButton.color.disabled(themeMode)};
            background: ${_colorPickerTheme.colorPickerTheme.colorSelector.addButton.backgroundColor.disabled(themeMode)};
            cursor: not-allowed;
            border-color: transparent;
        }
    `;
}}
`;
exports.AddButtonRoot = AddButtonRoot;
//# sourceMappingURL=AddButtonRoot.js.map